// Financial Performance: the routes and the sidebar rows of `wealth.intelligence.financial-performance` (ADR-0027).
import { defineWebFeature } from '@/features/kit';

export default defineWebFeature({
    id: 'wealth.intelligence.financial-performance',
    routes: [
        {
            frontend: 'view',
            path: 'financial-performance',
            lazy: () => import('@/pages/view/financial-performance/page'),
        },
    ],
    nav: [
        {
            frontend: 'view',
            key: 'financial-performance',
            label: 'Financial Performance',
            href: '/view/financial-performance',
            icon: 'TrendingUp',
            group: 'performance',
            order: 210,
        },
    ],
});
